import { useEffect, useRef, useState, type ReactNode } from "react";
import { BooksProvider, type BooksLinks } from "@/books/BooksProvider";
import { useDolfinAuth } from "@/components/DolfinProvider";
import { useChat } from "@/components/chat/ChatProvider";
import { useIsDemo } from "@/demo/DemoContext";

const LINKS: BooksLinks = {
  invoice: (id) => `/invoices/${id}`,
  bill: (id) => `/bills/${id}`,
  expense: (id) => `/expenses/${id}`,
  creditNote: (id) => `/credit-notes/${id}`,
  supplierCreditNote: (id) => `/supplier-credit-notes/${id}`,
  accountingConnection: "/organisation/settings/accounting",
  bankConnections: "/organisation/bank-connections",
};

/** Hands the self-contained books/ folder the sandbox's session (D20). */
export function SandboxBooksProvider({ children }: { children: ReactNode }) {
  const { baseUrl, authFetch, role } = useDolfinAuth();
  // The agent can match and categorise bank lines from chat (D30); each finished turn re-reads the books on screen.
  const { isStreaming, openChat } = useChat();
  const isDemo = useIsDemo();
  const [agentTurns, setAgentTurns] = useState(0);
  const wasStreaming = useRef(false);
  useEffect(() => {
    if (wasStreaming.current && !isStreaming) setAgentTurns((n) => n + 1);
    wasStreaming.current = isStreaming;
  }, [isStreaming]);
  return (
    <BooksProvider
      baseUrl={baseUrl}
      authFetch={authFetch}
      role={role}
      links={LINKS}
      changes={agentTurns}
      // Closing books is not on a demo organisation's allowlist (D7).
      canClose={!isDemo}
      askAgent={openChat}
    >
      {children}
    </BooksProvider>
  );
}
